export type LiigaDivision = "All";

export interface LiigaTeam {
  id: string;
  name: string;
  nameFi: string;
  abbr: string;
  city: string;
  logo: string;
  division: LiigaDivision;
}

// Liiga team logos from TheSportsDB
const LIIGA_LOGOS: Record<string, string> = {
  "1": "https://r2.thesportsdb.com/images/media/team/badge/n5or7y1656777168.png",   // Tappara
  "2": "https://r2.thesportsdb.com/images/media/team/badge/w3bkgc1656776964.png",   // HIFK
  "3": "https://r2.thesportsdb.com/images/media/team/badge/o7pjjp1656777031.png",   // Kärpät
  "4": "https://r2.thesportsdb.com/images/media/team/badge/eotx0h1656776986.png",   // Ilves
  "5": "https://r2.thesportsdb.com/images/media/team/badge/xz1y6j1656777058.png",   // Lukko
  "6": "https://r2.thesportsdb.com/images/media/team/badge/bnhlfl1656777009.png",   // JYP
  "7": "https://r2.thesportsdb.com/images/media/team/badge/gqy5l51656777104.png",   // Pelicans
  "8": "https://r2.thesportsdb.com/images/media/team/badge/m9wlmn1656777018.png",   // KalPa
  "9": "https://r2.thesportsdb.com/images/media/team/badge/f8r6r41656777042.png",   // KooKoo
  "10": "https://r2.thesportsdb.com/images/media/team/badge/m2tpvf1656777128.png",  // SaiPa
  "11": "https://r2.thesportsdb.com/images/media/team/badge/b1v2hj1656776937.png",  // Ässät
  "12": "https://r2.thesportsdb.com/images/media/team/badge/vq31so1656776974.png",  // HPK
  "13": "https://r2.thesportsdb.com/images/media/team/badge/uehx3c1656777188.png",  // TPS
  "14": "https://r2.thesportsdb.com/images/media/team/badge/ifjfpt1656777147.png",  // Sport
  "15": "https://r2.thesportsdb.com/images/media/team/badge/9rlzwe1656777024.png",  // Jukurit
  "16": "https://r2.thesportsdb.com/images/media/team/badge/oqjfhb1656777082.png",  // Mikkelin Jukurit → duplicate removed
};

const getLiigaLogo = (teamId: string) => LIIGA_LOGOS[teamId] ?? "";

export const LIIGA_TEAMS: LiigaTeam[] = [
  { id: "1", name: "Tappara", nameFi: "Tappara", abbr: "TAP", city: "Tampere", logo: getLiigaLogo("1"), division: "All" },
  { id: "2", name: "HIFK", nameFi: "HIFK", abbr: "HIFK", city: "Helsinki", logo: getLiigaLogo("2"), division: "All" },
  { id: "3", name: "Kärpät", nameFi: "Kärpät", abbr: "KAR", city: "Oulu", logo: getLiigaLogo("3"), division: "All" },
  { id: "4", name: "Ilves", nameFi: "Ilves", abbr: "ILV", city: "Tampere", logo: getLiigaLogo("4"), division: "All" },
  { id: "5", name: "Lukko", nameFi: "Lukko", abbr: "LUK", city: "Rauma", logo: getLiigaLogo("5"), division: "All" },
  { id: "6", name: "JYP", nameFi: "JYP", abbr: "JYP", city: "Jyväskylä", logo: getLiigaLogo("6"), division: "All" },
  { id: "7", name: "Pelicans", nameFi: "Pelicans", abbr: "PEL", city: "Lahti", logo: getLiigaLogo("7"), division: "All" },
  { id: "8", name: "KalPa", nameFi: "KalPa", abbr: "KAL", city: "Kuopio", logo: getLiigaLogo("8"), division: "All" },
  { id: "9", name: "KooKoo", nameFi: "KooKoo", abbr: "KOO", city: "Kouvola", logo: getLiigaLogo("9"), division: "All" },
  { id: "10", name: "SaiPa", nameFi: "SaiPa", abbr: "SAI", city: "Lappeenranta", logo: getLiigaLogo("10"), division: "All" },
  { id: "11", name: "Ässät", nameFi: "Ässät", abbr: "ASS", city: "Pori", logo: getLiigaLogo("11"), division: "All" },
  { id: "12", name: "HPK", nameFi: "HPK", abbr: "HPK", city: "Hämeenlinna", logo: getLiigaLogo("12"), division: "All" },
  { id: "13", name: "TPS", nameFi: "TPS", abbr: "TPS", city: "Turku", logo: getLiigaLogo("13"), division: "All" },
  { id: "14", name: "Sport", nameFi: "Sport", abbr: "SPO", city: "Vaasa", logo: getLiigaLogo("14"), division: "All" },
  { id: "15", name: "Jukurit", nameFi: "Jukurit", abbr: "JUK", city: "Mikkeli", logo: getLiigaLogo("15"), division: "All" },
];

export const LIIGA_DIVISIONS: LiigaDivision[] = ["All"];

export const getLiigaTeamByAbbr = (abbr: string): LiigaTeam | undefined => {
  return LIIGA_TEAMS.find((team) => team.abbr === abbr);
};
